import React, { useEffect, useState } from "react";
import { getCoinTransactions } from "../../services/walletService";
import { format } from "date-fns";
import {
  ChevronLeft,
  ChevronRight,
  ArrowUpRight,
  ArrowDownLeft,
  Trophy,
  Wallet,
  CreditCard,
  RefreshCcw,
  Filter,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";

const FILTER_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Withdraw", value: "withdraw" },
  { label: "Add Funds", value: "add_funds" },
  { label: "Reward", value: "reward" },
];

const TransactionHistory = ({
  limit,
  hidePagination = false,
  showHeading = true,
  showFilter = true,
}) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState("all");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [pagination, setPagination] = useState({
  totalCount: 0,
  pageNo: 1,
  limit: 10,
  totalPagesCount: 1,
});
   const navigate = useNavigate();


const fetchTransactions = async () => {
  setLoading(true);

  try {
    // API se sab transactions lao
    const data = await getCoinTransactions(page, limit || 10);

    let allTransactions = data.result.transactions || [];

    // Frontend filtering
    if (filter === "withdraw") {
      allTransactions = allTransactions.filter(
        (txn) => txn.type === "withdrawn"
      );
    }

    if (filter === "add_funds") {
      allTransactions = allTransactions.filter(
        (txn) => txn.type === "recharge"
      );
    }

    if (filter === "reward") {
      allTransactions = allTransactions.filter((txn) =>
        [
          "earned_question",
          "earned_contest",
          "earned_referral",
          "earned_referral_bonus",
          "refund",
        ].includes(txn.type)
      );
    }

    setTransactions(allTransactions);
      setPagination(
      data?.result?.pagination || {
        totalCount: 0,
        pageNo: 1,
        limit: 10,
        totalPagesCount: 1,
      }
    );

    // setTotalPages(data.result.pagination.totalPagesCount || 1);

  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchTransactions();
  }, [page, limit, filter]);

  const handlePrevPage = () => {
  navigate(-1);
};

  const handleFilterChange = (value) => {
    setFilter(value);
    setPage(1);
    setIsFilterOpen(false);
  };

  const activeFilterLabel =
    FILTER_OPTIONS.find((item) => item.value === filter)?.label || "All";

  const formatTransactionTitle = (type) => {
    if (!type) return "Transaction";

    const titleMap = {
      recharge: "Credits Added",
      spent_contest: "Contest Entry",
      earned_contest: "Contest Reward",
      spent_plan: "Plan Purchase",
      earned_question: "Quiz Reward",
      spent_question: "Quiz Deducted",
      withdrawn: "Withdraw Request",
      refund: "Refund",
    };

    return (
      titleMap[type] ||
      type
        .replaceAll("_", " ")
        .replace(/\b\w/g, (char) => char.toUpperCase())
    );
  };

  const getTransactionIcon = (type, amount) => {
    if (type === "earned_contest") return Trophy;
    if (type === "earned_question") return Trophy;
    if (type === "recharge") return Wallet;
    if (type === "refund") return RefreshCcw;
    if (type === "withdrawn") return ArrowUpRight;
    if (amount > 0) return ArrowDownLeft;

    return CreditCard;
  };

  const getStatusLabel = (txn) => {
    return txn.status || txn.paymentStatus || "COMPLETED";
  };

  const isSuccessStatus = (status) => {
    const value = status?.toLowerCase();

    return (
      value === "completed" ||
      value === "success" ||
      value === "successful" ||
      value === "paid"
    );
  };



  return (
<div className="w-full h-screen bg-[#F7F3FA] flex flex-col">
 {(showHeading || showFilter) && (
  <div className=" lg:mt-10 p-5 flex flex-col gap-4">

    {/* Heading */}
    {showHeading && (
      <div className="flex items-start gap-3 min-w-0">
        <button
          type="button"
          onClick={handlePrevPage}
          className="shrink-0 bg-[#562566]/10 text-[#562566] w-9 h-9 flex items-center justify-center rounded-full"
        >
          <FaAngleLeft />
        </button>

        <div className="min-w-0">
          <h2 className="text-xl font-bold text-[#34163F] leading-tight">
            All Transaction History
          </h2>
        </div>
      </div>
    )}

    {/* Filter Tabs */}
    {showFilter && (
      <div className="no-scrollbar">
        <div className="flex gap-2 min-w-max ">
          {FILTER_OPTIONS.map((item) => {
            const isActive = filter === item.value;

            return (
              <button
                key={item.value || "all"}
                type="button"
                onClick={() => handleFilterChange(item.value)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-all duration-200 ${
                  isActive
                    ? "bg-[#562566] text-white shadow-md "
                    : "text-black  bg-purple-50"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    )}
  </div>
)}


      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="w-8 h-8 border-3 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : transactions.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12  text-gray-500">
          <ArrowDownLeft size={40} className="mb-3 opacity-30" />
          <p className="text-sm">No transactions found.</p>
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto p-4">
  <div className="space-y-2">
          {transactions.map((txn) => {
            const isCredit = Number(txn.amount) > 0;
            const status = getStatusLabel(txn);
            const success = isSuccessStatus(status);
            const Icon = getTransactionIcon(txn.type, txn.amount);

            return (
              <div
                key={txn._id}
                className={`bg-white rounded-xl p-4 shadow-sm flex justify-between items-center border-l-4 ${
                  isCredit ? "border-green-400" : "border-red-400"
                }`}
              >
                <div className="flex items-center gap-3 min-w-0">
                  <div
                    className={`flex w-10 h-10 rounded-full items-center justify-center shrink-0 ${
                      isCredit ? "bg-green-100" : "bg-red-100"
                    }`}
                  >
                    <Icon
                      size={18}
                      className={isCredit ? "text-green-600" : "text-red-600"}
                    />
                  </div>

                  <div className="min-w-0">
                    <p className="font-medium text-gray-800 truncate">
                      {formatTransactionTitle(txn.type)}
                    </p>

                    <p className="text-xs text-gray-400 mt-1">
                      {txn.createdOn
                        ? format(new Date(txn.createdOn), "dd-MM-yy hh:mm a")
                        : ""}
                    </p>

                    <span
                      className={`text-xs font-semibold uppercase ${
                        success ? "text-green-500" : "text-red-500"
                      }`}
                    >
                      {status}
                    </span>
                  </div>
                </div>

                <div
                  className={`text-right font-bold shrink-0 ${
                    isCredit ? "text-green-500" : "text-red-500"
                  }`}
                >
                  {isCredit ? "+" : ""}
                  {txn.amount}

                  <p className="text-xs text-gray-700 font-semibold">
                    Credits
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        </div>
      )}

    {!hidePagination && pagination.totalPagesCount > 1 && (
  <div className="flex items-center justify-center gap-4 mt-2 mb-4">
    <button
      onClick={() => setPage((p) => Math.max(1, p - 1))}
      disabled={pagination.pageNo <= 1}
      className="p-2 rounded-lg bg-white border"
    >
      <ChevronLeft size={16} />
    </button>

    <span className="text-sm">
      Page {pagination.pageNo} of {pagination.totalPagesCount}
    </span>

    <button
      onClick={() =>
        setPage((p) =>
          Math.min(pagination.totalPagesCount, p + 1)
        )
      }
      disabled={
        pagination.pageNo >= pagination.totalPagesCount
      }
      className="p-2 rounded-lg bg-white border"
    >
      <ChevronRight size={16} />
    </button>
  </div>
)}
    </div>
  );
};

export default TransactionHistory;